/**
 * Generated by orval v8.6.2 🍺
 * Do not edit manually.
 * SEFANO
 * API documentation
 * OpenAPI spec version: 1.0
 */

export type CommissionInvoiceStatus = typeof CommissionInvoiceStatus[keyof typeof CommissionInvoiceStatus];


export const CommissionInvoiceStatus = {
  pending: 'pending',
  paid: 'paid',
  failed: 'failed',
  canceled: 'canceled',
} as const;
